import { createContext, useContext, useState, useEffect } from 'react'
import { authAPI } from '../api/auth'

const AuthContext = createContext(null)

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [isTokenExpired, setIsTokenExpired] = useState(false)

  useEffect(() => {
    // Check authentication status on mount
    const authenticated = authAPI.isAuthenticated()
    setIsAuthenticated(authenticated)
    setIsLoading(false)
  }, [])

  const login = async (email, password) => {
    try {
      const { token } = await authAPI.login(email, password)
      setIsAuthenticated(!!token)
      setIsTokenExpired(false)
      return { success: true }
    } catch (error) {
      return { success: false, error: error.response?.data?.message || 'Login failed' }
    }
  }

  const logout = () => {
    authAPI.logout()
    setIsAuthenticated(false)
    setIsTokenExpired(false)
  }

  const setTokenExpired = (expired) => {
    setIsTokenExpired(expired)
    if (expired) {
      setIsAuthenticated(false)
    }
  }

  return (
    <AuthContext.Provider value={{ 
      isAuthenticated, 
      isLoading, 
      login, 
      logout,
      isTokenExpired,
      setTokenExpired
    }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider')
  }
  return context
}

